import { CommonIcons } from 'common-src/assets/Icons';

export const getDataByChannel = (channel) => {
  if (channel.includes('VOICE')) {
    return { label: 'Phone Call', icon: CommonIcons.phoneCallIncon };
  }

  if (channel.includes('SMS')) {
    return { label: 'SMS Conversation', icon: CommonIcons.smsIcon };
  }

  return { label: 'Reminder', icon: CommonIcons.reminderIcon };
};
